export default "__VITE_ASSET__CSpUovJa__"